import React, { useState, useEffect } from 'react';
import { usePersona } from '@/contexts/PersonaContext';
import { DashboardPage } from '@/components/Pages/DashboardPage';
import { ManagerDashboard } from './ManagerDashboard';
import { cn } from '@/lib/utils';

interface PersonaDashboardProps {
  onNavigate?: (path: string) => void;
}

export const PersonaDashboard: React.FC<PersonaDashboardProps> = ({ onNavigate }) => {
  const { currentPersona } = usePersona();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayPersona, setDisplayPersona] = useState(currentPersona);

  // Handle smooth transition between personas
  useEffect(() => {
    if (currentPersona !== displayPersona) {
      setIsTransitioning(true);
      
      // Wait for fade out
      const timer = setTimeout(() => {
        setDisplayPersona(currentPersona);
        setIsTransitioning(false);
      }, 150); // Half of the transition duration

      return () => clearTimeout(timer);
    }
  }, [currentPersona, displayPersona]);

  return (
    <div className="space-y-6">
      {/* Dashboard Content with Transition - Toggle now integrated in each dashboard header */}
      <div
        className={cn(
          'transition-opacity duration-300',
          isTransitioning ? 'opacity-0' : 'opacity-100'
        )}
      >
        {displayPersona === 'personal' ? (
          <DashboardPage onNavigate={onNavigate} />
        ) : (
          <ManagerDashboard onNavigate={onNavigate} />
        )}
      </div>
    </div>
  );
};
